export const OPEN_DRAWER = 'app/OPEN_DRAWER'
export const CLOSE_DRAWER = 'app/CLOSE_DRAWER'
export const TOGGLE_SIDEBAR = 'app/TOGGLE_SIDEBAR'
export const SET_SNACKBAR_NOTIFICATION = 'app/SET_SNACKBAR_NOTIFICATION'
export const SET_COUNTRY = 'app/SET_COUNTRY'
